var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.998535,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#E4EBF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6253 16.7568H8.50494L6.91495 10.6909C6.83949 10.4119 6.67925 10.1652 6.44354 10.0489C5.85531 9.75677 5.20712 9.52424 4.5 9.40697V9.17343H7.91567C8.38708 9.17343 8.74064 9.52424 8.79957 9.93166L9.62454 14.3072L11.7438 9.17343H13.8052L10.6253 16.7568ZM14.9838 16.7568H12.9813L14.6302 9.17343H16.6327L14.9838 16.7568ZM19.2234 11.2742C19.2823 10.8658 19.6359 10.6323 20.0483 10.6323C20.6965 10.5736 21.4026 10.6909 21.9919 10.9821L22.3454 9.34934C21.7562 9.11581 21.108 8.99854 20.5198 8.99854C18.5762 8.99854 17.162 10.0489 17.162 11.5068C17.162 12.6158 18.1637 13.1981 18.8708 13.549C19.6359 13.8987 19.9305 14.1323 19.8716 14.4821C19.8716 15.0068 19.2823 15.2403 18.6941 15.2403C17.9869 15.2403 17.2798 15.0654 16.6327 14.7732L16.2791 16.407C16.9862 16.6982 17.7512 16.8154 18.4584 16.8154C20.6376 16.873 21.9919 15.8237 21.9919 14.2485C21.9919 12.265 19.2234 12.1487 19.2234 11.2742ZM29 16.7568L27.41 9.17343H25.7022C25.3486 9.17343 24.9951 9.40697 24.8772 9.75677L21.9329 16.7568H23.9943L24.4058 15.6487H26.9386L27.1743 16.7568H29ZM25.9968 11.2156L26.585 14.0737H24.9361L25.9968 11.2156Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard01);
export default __webpack_public_path__ + "static/media/card-01.83dcfc9643c3273f9d5d9dd96644c334.svg";
export { ForwardRef as ReactComponent };